<template>
  <div class="min-h-screen font-sans bg-brand-bg text-brand-dark">
    <Header />
    <main class="container mx-auto px-4 py-8 md:py-16">
      <div class="max-w-6xl mx-auto">
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
          <!-- Left side - Image -->
          <div class="flex items-center justify-center">
            <div class="relative overflow-hidden">
              <img
                src="@/assets/customer.png"
                alt="Customer Service Representative"
                class="w-full h-auto object-cover"
                style="max-width: 576px; max-height: 683px"
              />
            </div>
          </div>

          <!-- Right side - Contact Form -->
          <div class="flex">
            <div class="p-8">
              <h1
                class="text-3xl font-bold mb-6 text-center uppercase tracking-wide"
              >
                {{ $t("contactUs.title") }}
              </h1>

              <div class="mb-8 text-gray-600 text-sm leading-relaxed">
                <p class="mb-4">
                  {{ $t("contactUs.description") }}
                </p>
                <div class="space-y-2">
                  <p>
                    <span class="font-medium"
                      >{{ $t("contactUs.email") }}:</span
                    >
                    support@socheerfull.vip
                  </p>
                  <p>
                    <span class="font-medium"
                      >{{ $t("contactUs.phone") }}:</span
                    >
                    +1 (855) 522 0987
                  </p>
                  <p class="text-xs text-gray-500">
                    {{ $t("contactUs.workingHours") }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/header";
import Footer from "@/components/footer";

export default {
  name: "ContactUs",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      form: {
        name: "",
        email: "",
        country: "",
        productModel: "",
        amazonOrderNumber: "",
        problemsEncountered: "",
      },
      errors: {},
      isSubmitting: false,
      submitSuccess: false,
    };
  },
  methods: {
    validateForm() {
      this.errors = {};

      if (!this.form.name.trim()) {
        this.errors.name = this.$t("contactUs.form.errors.nameRequired");
      }

      if (!this.form.email.trim()) {
        this.errors.email = this.$t("contactUs.form.errors.emailRequired");
      } else if (!this.isValidEmail(this.form.email)) {
        this.errors.email = this.$t("contactUs.form.errors.emailInvalid");
      }

      if (!this.form.country.trim()) {
        this.errors.country = this.$t("contactUs.form.errors.countryRequired");
      }

      if (!this.form.amazonOrderNumber.trim()) {
        this.errors.amazonOrderNumber = this.$t(
          "contactUs.form.errors.amazonOrderNumberRequired"
        );
      }

      return Object.keys(this.errors).length === 0;
    },

    isValidEmail(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    },

    async handleSubmit() {
      if (!this.validateForm()) {
        return;
      }

      this.isSubmitting = true;
      this.submitSuccess = false;

      try {
        // Simulate API call
        await new Promise((resolve) => setTimeout(resolve, 2000));

        // Here you would typically send the form data to your backend
        console.log("Form submitted:", this.form);

        this.submitSuccess = true;
        this.resetForm();
      } catch (error) {
        console.error("Submit error:", error);
        // Handle error - you could show an error message here
      } finally {
        this.isSubmitting = false;
      }
    },

    resetForm() {
      this.form = {
        name: "",
        email: "",
        country: "",
        productModel: "",
        amazonOrderNumber: "",
        problemsEncountered: "",
      };
      this.errors = {};
    },
  },
};
</script>

<style scoped>
/* Add any additional custom styles here */
.brand-bg {
  background-color: #f8f9fa;
}

.brand-dark {
  color: #1a202c;
}

.brand-red {
  color: #e53e3e;
}
</style>
